import { SVGProps } from 'react';

export const LoadingSpinningIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M9 1C13.4158 1 17 4.59039 17 9.02441C16.9998 13.4582 13.4156 17.0479 9 17.0479C4.58438 17.0479 1.00024 13.4582 1 9.02441C1 4.59039 4.58423 1 9 1Z"
        stroke="#DFE2E7"
        strokeWidth="2"
      />
      <path
        d="M9.04785 17.0102C9.04785 17.5833 9.514 18.0541 10.0833 17.988C10.9096 17.8921 11.7204 17.6815 12.492 17.361C13.5839 16.9075 14.5761 16.2428 15.4118 15.4049C16.2475 14.5669 16.9105 13.5721 17.3628 12.4773C17.8151 11.3825 18.0479 10.209 18.0479 9.02397C18.0479 7.83892 17.8151 6.66548 17.3628 5.57064C16.9105 4.47581 16.2475 3.48101 15.4118 2.64306C14.5761 1.80511 13.5839 1.14041 12.492 0.686909C11.7204 0.366445 10.9096 0.155882 10.0833 0.0599219C9.514 -0.00619148 9.04785 0.46462 9.04785 1.03776C9.04785 1.61089 9.51503 2.06755 10.0817 2.15327C10.6361 2.23714 11.1795 2.38833 11.6998 2.60443C12.5406 2.95362 13.3046 3.46544 13.9481 4.11067C14.5916 4.75589 15.1021 5.52188 15.4503 6.36491C15.7986 7.20793 15.9779 8.11148 15.9779 9.02397C15.9779 9.93645 15.7986 10.84 15.4503 11.683C15.1021 12.5261 14.5916 13.292 13.9481 13.9373C13.3046 14.5825 12.5406 15.0943 11.6998 15.4435C11.1795 15.6596 10.6361 15.8108 10.0817 15.8947C9.51503 15.9804 9.04785 16.437 9.04785 17.0102Z"
        fill={props.fill ?? '#0071CD'}
      />
      <animateTransform
        type="rotate"
        attributeName="transform"
        calcMode="spline"
        dur="1"
        values="360;0"
        keyTimes="0;1"
        keySplines="0 0 1 1"
        repeatCount="indefinite"
      ></animateTransform>
    </svg>
  );
};
